import { ReactNode } from 'react';

interface CommonRowData {
  nid: string;
  processName?: string;
}

/**
 * Renderiza las celdas comunes de las tablas de chart:
 * - No. (número de fila)
 * - NID (con botón clickeable)
 * - Nombre del Proceso (opcional)
 */
export const renderCommonCells = (
  row: CommonRowData,
  index: number,
  handleNidClick: (nid: string) => void
): ReactNode => {
  return (
    <>
      <td>{index + 1}</td>
      <td>
        <button
          className="btn btn-link p-0 text-decoration-none"
          onClick={() => handleNidClick(row.nid)}
          style={{ cursor: 'pointer' }}
        >
          {row.nid}
        </button>
      </td>
      {row.processName && <td>{row.processName}</td>}
    </>
  );
};

